import { __decorate, __extends } from "tslib";
import { AbpBase } from '@/lib/AbpBase';
import Template from './OrganizationEditModal.html';
import { Component } from 'vue-property-decorator';
import { OrganizationUnitServiceProxy, OrganizationUnitDto, CreateOrganizationUnitInput, UnitType, UpdateOrganizationUnitInput } from '@/lib/service-proxy/service-proxies';
import SelectOrganizationModal from '@/views/common-components/SelectOrganizationModal';
import OrganizationSelect from '@/views/common-components/OrganizationSelect';
// @ts-ignore
var OrganizationEditModal = /** @class */ (function (_super) {
    __extends(OrganizationEditModal, _super);
    function OrganizationEditModal() {
        var _this = _super.call(this) || this;
        _this.saving = false;
        _this.parentType = UnitType.Unit;
        _this.visible = false;
        _this.selectedUnitIds = [];
        _this.service = new OrganizationUnitServiceProxy();
        _this.dto = new OrganizationUnitDto();
        return _this;
    }
    Object.defineProperty(OrganizationEditModal.prototype, "form", {
        get: function () {
            return this.$refs.form;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganizationEditModal.prototype, "title", {
        get: function () {
            return this.dto.id ? '编辑节点' : '添加节点';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganizationEditModal.prototype, "rules", {
        get: function () {
            return {
                displayName: { required: true, message: '请输入全称', trigger: 'blur' },
                unitType: { required: true, message: '请选择节点类型', trigger: 'change' }
            };
        },
        enumerable: true,
        configurable: true
    });
    OrganizationEditModal.prototype.open = function (dto, parentType) {
        this.dto = dto;
        this.parentType = parentType;
        this.visible = true;
    };
    OrganizationEditModal.prototype.handleSaveClick = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.form.validate(function (valid) {
            if (valid) {
                _this.saving = true;
                if (!_this.dto.id) {
                    var createDto = CreateOrganizationUnitInput.fromJS(_this.dto);
                    createDto.designatedRanges = _this.selectedUnitIds;
                    _this.service
                        .createOrganizationUnit(createDto)
                        .then(function (result) {
                        _this.dto = result;
                        _this.$Notice.success({
                            title: '保存成功'
                        });
                        _this.form.resetFields();
                        _this.visible = false;
                        _this.$emit('on-saved', result);
                    })
                        .finally(function () {
                        _this.saving = false;
                    });
                }
                else {
                    var updateDto = UpdateOrganizationUnitInput.fromJS(_this.dto);
                    updateDto.designatedRanges = _this.selectedUnitIds;
                    _this.service
                        .updateOrganizationUnit(updateDto)
                        .then(function (result) {
                        _this.dto = result;
                        _this.$Notice.success({
                            title: '保存成功'
                        });
                        _this.form.resetFields();
                        _this.visible = false;
                        _this.$emit('on-saved', result);
                    })
                        .finally(function () {
                        _this.saving = false;
                    });
                }
            }
        });
    };
    OrganizationEditModal.prototype.handleCancelClick = function () {
        this.visible = false;
        this.form.resetFields();
    };
    OrganizationEditModal = __decorate([
        Component({
            components: {
                SelectOrganizationModal: SelectOrganizationModal,
                OrganizationSelect: OrganizationSelect,
            }
        }),
        Template
    ], OrganizationEditModal);
    return OrganizationEditModal;
}(AbpBase));
export default OrganizationEditModal;
